// src/pages/nationalities/CreateNationalities.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditNationalities from "../../components/nationalities/FormAddEditNationalities";
import { useNavigate } from "react-router-dom";

const CreateNationalities = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditNationalities
                isEdit={false}
                onSubmitSuccess={() => navigate("/nationalities")}
            />
        </WrapperSection>
    );
};

export default CreateNationalities;